import { Navigate, Outlet } from 'react-router-dom'
import { PATHS } from '../../constants/routes'
import { useAuth } from '../../hooks/useAuth'
import FullPageLoading from './FullPageLoading'

export const RequireAuth = () => {
  const { isLoading, isAuthenticated } = useAuth()
  return isLoading ? <FullPageLoading /> : isAuthenticated ? <Outlet /> : <Navigate to={PATHS.LOGIN} replace />
}
